<template>
    <div
        v-if="isPageLoaded"
        class="partner-badges"
        :class="badgeType"
    >
        <div class="hero-banner">
            <div class="container text-center white--text">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-13"
                >
                    <v-col cols="12" lg="9" class="pa-lg-0">
                        <h1>{{ page.pageTitle }}</h1>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-10"
                >
                    <v-col cols="10" sm="8" md="7" lg="6" class="pa-lg-0">
                        <p v-html="page.pageSubtitle"></p>
                    </v-col>
                </v-row>

                <v-row class="ma-0 mb-2 mb-md-6">
                    <v-col class="d-flex justify-center pa-lg-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToPartnerBadges"
                        >
                            <span>Choose Your Badge</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div id="partner-badges-section" class="partner-badges-section section">
            <div class="content">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-12"
                >
                    <v-col cols="12" lg="7" class="pa-lg-0">
                        <h2>{{ page.badgesTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-12"
                >
                    <v-col cols="10" sm="8" lg="7" class="pa-lg-0">
                        <p>{{ page.badgesContent }}</p>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-12"
                >
                    <v-col cols="12" class="pa-lg-0">
                        <v-avatar color="primary" size="45">
                            <span class="white--text font-weight-bold">1</span>
                        </v-avatar>
                    </v-col>
                    <v-col cols="12" class="pa-0 pt-4">
                        <p>Select your preferred option below.</p>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-12"
                >
                    <v-col cols="12" class="pa-lg-0">
                        <v-avatar color="primary" size="45">
                            <span class="white--text font-weight-bold">2</span>
                        </v-avatar>
                    </v-col>
                    <v-col cols="12" class="pa-0 pt-4">
                        <p>Click the 'Copy Code' button.</p>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-10"
                >
                    <v-col cols="12" class="pa-lg-0">
                        <v-avatar color="primary" size="45">
                            <span class="white--text font-weight-bold">3</span>
                        </v-avatar>
                    </v-col>
                    <v-col cols="12" class="pa-0 pt-4">
                        <p>Right-click and paste your code where desired in the backend of your site.</p>
                    </v-col>
                </v-row>

                <template v-for="(badges, type) in badgeTypes">
                    <v-row
                        :key="`badges-${type}`"
                        justify="center"
                        class="ma-0 mb-4 mb-md-8 mb-lg-10"
                    >
                        <v-col cols="12" class="pa-lg-0">
                            <v-card
                                elevation="4"
                                class="px-6 py-8 text-center"
                            >
                                <v-card-title class="ma-0 mb-6">
                                    <h3>{{ type }}</h3>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <template v-for="(badge, index) in badges">
                                            <v-col :key="index" cols="12" md="4" class="py-0 px-5">
                                                <h4>{{  badge.color }}</h4>
                                                <div
                                                    class="badge-wrapper d-flex flex-column justify-center"
                                                    :class="(badge.color === 'WHITE' ? 'dark' : '')"
                                                >
                                                    <img
                                                        :src="badge.img"
                                                        :width="(type === 'LARGE' ? 180 : 120)"
                                                        class="mx-auto mb-6"
                                                    >
                                                    <v-btn
                                                        color="primary"
                                                        depressed
                                                        large
                                                        v-on:click.prevent="copyBadgeCode(type, badge.img)"
                                                    >
                                                        <span>Copy Code</span>
                                                    </v-btn>
                                                </div>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
            </div>
        </div>

        <div class="call-to-action section">
            <div class="content">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-lg-6"
                >
                    <v-col cols="12" lg="9" class="pa-lg-0">
                        <h2>{{ page.footerTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-lg-6"
                >
                    <v-col cols="10" sm="8" md="7" lg="5" class="pa-lg-0">
                        <p>{{ page.footerContent }}</p>
                    </v-col>
                </v-row>

                <v-row class="ma-0 mb-2">
                    <v-col class="d-flex justify-center pa-lg-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            to="/contact"
                        >
                            <span>Contact Us</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import SiteService from '@/services/site.service';
import { getMediaPathUrl } from '@/utils/helpers';

export default {
    name: 'PartnerBadges',

    props: {
        badgeType: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            page: {
                pageTitle: '',
                pageSubtitle: '',

                badgesTitle: '',
                badgesContent: '',

                footerTitle: '',
                footerContent: '',

                badgeColorSmall: null,
                badgeBlackSmall: null,
                badgeWhiteSmall: null,

                badgeColorLarge: null,
                badgeBlackLarge: null,
                badgeWhiteLarge: null,
            },
        };
    },

    computed: {
        badgeTypes() {
            if (! this.isPageLoaded) {
                return null;
            }

            return {
                SMALL: [
                    { color: 'COLOR', img: this.getImageUrl(this.page.badgeColorSmall) },
                    { color: 'BLACK', img: this.getImageUrl(this.page.badgeBlackSmall) },
                    { color: 'WHITE', img: this.getImageUrl(this.page.badgeWhiteSmall) },
                ],
                LARGE: [
                    { color: 'COLOR', img: this.getImageUrl(this.page.badgeColorLarge) },
                    { color: 'BLACK', img: this.getImageUrl(this.page.badgeBlackLarge) },
                    { color: 'WHITE', img: this.getImageUrl(this.page.badgeWhiteLarge) },
                ],
            };
        },

        isPageLoaded() {
            return this.page?.pageTitle?.length > 0;
        },
    },

    watch: {
        badgeType: {
            handler: function() {
                this.init();
            },
            immediate: true,
        },
    },

    methods: {
        copyBadgeCode(badgeType, badgeImage) {
            const width = badgeType === 'LARGE' ? '180' : '120';
            const copyText = `<img src="${badgeImage}" width="${width}" />`;

            // Copy the text to the clipboard
            navigator.clipboard.writeText(copyText);
        },

        /**
         * Attempt to get the file path from the specified image object.
         * @param {Object} image
         * @returns {string}
         */
        getImageUrl(image) {
            try {
                return getMediaPathUrl(image);
            } catch (thrown) {
                return '';
            }
        },

        async init() {
            // Set the menu to transparent
            this.$store.commit('setHeaderMenuState', 'transparent');

            // Get the page data
            const response = await SiteService.getBadgesPage(this.badgeType);
            if (response == null) {
                return this.$router.push('/');
            }

            // Check that the response returned the page with pageTitle, otherwise return to the homepage
            const page = response?.attributes;
            if (page == null || page?.pageTitle == null) {
                return this.$router.push('/');
            }

            this.page = page;
        },

        /**
         * Scroll to the partner-badges section of the page.
         */
        scrollToPartnerBadges() {
            const offset = this.$vuetify.breakpoint.mdAndDown ? -65 : 0;

            this.$scrollTo('#partner-badges-section', 500, {
                offset,
            });
        },
    },
};
</script>

<style scoped>
/** Generic Page styles */
>>>.content>.row {
    width: 100%;
    margin: 0;
}

div.partner-badges {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

div.partner-badges .v-btn {
    text-transform: none;
    font-weight: bold;
}

div.hero-banner .container,
div.section .content {
    height: fit-content;
    width: 90%;
    max-width: 1505px;
    padding: 0 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    word-spacing: 1px;
    z-index: 2;
}

/** Hero Banner styles */
div.hero-banner {
    padding-top: 160px;
    padding-bottom: 55px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    max-height: 630px;
    min-height: 567px;
    background-image: url("../../src/assets/media/property-badge-header.png");
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

div.partner-badges.school  div.hero-banner {
    background-image: url("../../src/assets/media/school-badge-header.png");
}

div.hero-banner:before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(10, 10, 10, 0.75);
    z-index: 1;
}

div.hero-banner .container {
    padding: 0 10px;
}

div.hero-banner h1 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 64px;
    line-height: 72px;
    max-width: 1300px;
    margin: auto;
}

/** Section styles */
div.section {
    padding: 100px 0;
}

div.section h2,
div.section p {
    color: #000;
}

div.section h2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 1.5;
    margin: 0 auto;
}

div.section h3 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 1.5;
    margin: 0 auto;
    color: #000000;
}

div.section h4 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 1.5;
    margin: 10px auto;
    color: #000000;
}

div.section .v-avatar {
    font-size: 20px;
    line-height: 20px;
}

div.section .badge-wrapper {
    width: 100%;
    background-color: #f4f5f6;
    padding: 45px;
    border-radius: 5px;
}

div.section .badge-wrapper.dark {
    background-color: rgba(0, 0, 0, 0.15);
}

div.section .badge-wrapper .v-btn {
    margin: 0 auto;
}

/** Call to Action section styles */
div.call-to-action {
    padding-top: 110px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    max-height: 480px;
    min-height: 435px;
    background-image: url("../../src/assets/media/area-guide-footer.png");
    background-position: top center;
    background-size: cover;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    overflow: hidden;
}

@media (max-width: 450px) {
    div.section .badge-wrapper {
        padding: 20px 0px 20px 0px;
    }
    .v-application .px-5 {
        padding-right: 0px !important;
        padding-left: 0px !important;
    }

    div.call-to-action {
        max-height: 550px;
    }
    div.section h2 {
        font-size: 30px;
    }
}

div.call-to-action:before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(10, 10, 10, 0.75);
    z-index: 1;
}

div.call-to-action h2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 1.5;
    margin: 0 auto;
    color: #FFFFFF;
}

div.call-to-action p {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #FFFFFF;
}

div.call-to-action .v-btn {
    height: 45px;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: normal;
    text-transform: capitalize;
}

@media (max-width: 1400px) {
    div.hero-banner h1 {
        font-size: clamp(30px, 3em, 64px);
        line-height: 1.125;
    }

    div.call-to-action {
        background-size: cover !important;
    }
}

@media (max-width: 1264px) {
    div.hero-banner {
        max-height: 720px;
        min-height: 630px;
        padding-top: 170px;
    }
}

@media (max-width: 1024px) {
    div.hero-banner {
        padding: 0;
    }

    div.hero-banner .container,
    div.call-to-action .content {
        margin-top: auto;
        margin-bottom: auto;
        height: 100%;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }

    div.hero-banner h1 {
        font-size: clamp(30px, 3em, 50px);
        padding-left: 0;
        padding-right: 0;
    }
}

@media (max-width: 768px) {
    div.hero-banner .container,
    div.call-to-action .content {
        max-width: 100%;
    }

    div.hero-banner {
        padding-top: 100px;
        padding-bottom: 70px;
        min-height: 200px;
        height: auto;
    }

    div.hero-banner h1 {
        font-size: clamp(30px, 2em, 64px);
    }
}

@media (max-width: 575px) {
    div.hero-banner h1 {
        font-size: 30px;
    }
}
</style>
